// 계약구분 (상태)
export const CONTRACT_STATUSES = ['홀드', '가계약', '계약', '취소', '정산완료'] as const;

export const CONTRACT_STATUS_COLORS: Record<string, string> = {
  '홀드': 'bg-yellow-100 text-yellow-700',
  '가계약': 'bg-blue-100 text-blue-700',
  '계약': 'bg-green-100 text-green-700',
  '취소': 'bg-red-100 text-red-700',
  '정산완료': 'bg-gray-800 text-white',
};

// 고객경로
export const CUSTOMER_SOURCES = [
  { value: '워킹', label: '워킹' },
  { value: '인터넷', label: '인터넷' },
  { value: '지인', label: '지인' },
  { value: '기타', label: '기타' },
  { value: '업체', label: '업체' },
];

// 행사유형
export const EVENT_TYPES = [
  { value: '예식', label: '예식' },
  { value: '기업', label: '기업' },
  { value: '돌', label: '돌' },
  { value: '가족', label: '가족' },
  { value: '대관', label: '대관' },
];

export const EVENT_TYPE_COLORS: Record<string, string> = {
  '예식': 'bg-pink-100 text-pink-700',
  '기업': 'bg-blue-100 text-blue-700',
  '돌': 'bg-yellow-100 text-yellow-700',
  '가족': 'bg-green-100 text-green-700',
  '대관': 'bg-purple-100 text-purple-700',
};

// 일정 카테고리
export const SCHEDULE_CATEGORIES = [
  { value: 'TASK', label: '업무', color: 'bg-cyan-500' },
  { value: 'EVENT', label: '행사/예식', color: 'bg-pink-500' },
  { value: 'CONSULTATION', label: '상담', color: 'bg-green-500' },
  { value: 'TASTING', label: '시식', color: 'bg-orange-500' },
  { value: 'PAYMENT', label: '결제', color: 'bg-lime-500' },
];

export const SCHEDULE_CATEGORY_COLORS: Record<string, string> = {
  TASK: 'bg-cyan-100 text-cyan-700 border-cyan-300',
  EVENT: 'bg-pink-100 text-pink-700 border-pink-300',
  CONSULTATION: 'bg-green-100 text-green-700 border-green-300',
  TASTING: 'bg-orange-100 text-orange-700 border-orange-300',
  PAYMENT: 'bg-lime-100 text-lime-700 border-lime-300',
};

// 상담유형
export const CONSULTATION_TYPES = [
  { value: 'FIRST_VISIT', label: '초방' },
  { value: 'REVISIT', label: '재방' },
  { value: 'PHONE', label: '전화' },
  { value: 'ONLINE', label: '온라인' },
];

export const CONSULTATION_TYPE_COLORS: Record<string, string> = {
  FIRST_VISIT: 'bg-blue-100 text-blue-700',
  REVISIT: 'bg-teal-100 text-teal-700',
  PHONE: 'bg-gray-100 text-gray-700',
  ONLINE: 'bg-indigo-100 text-indigo-700',
};

// 일정 상태
export const SCHEDULE_STATUSES = ['예정', '진행중', '완료', '취소', '노쇼'] as const;

export const SCHEDULE_STATUS_COLORS: Record<string, string> = {
  '예정': 'bg-blue-100 text-blue-700',
  '진행중': 'bg-indigo-100 text-indigo-700',
  '완료': 'bg-green-100 text-green-700',
  '취소': 'bg-red-100 text-red-700',
  '노쇼': 'bg-gray-800 text-white',
};

// 결제 유형 (DEPOSIT 추가)
export const PAYMENT_TYPES = [
  { value: 'DEPOSIT', label: '예약금' },
  { value: 'CONTRACT', label: '계약금' },
  { value: 'INTERMEDIATE', label: '중도금' },
  { value: 'BALANCE', label: '잔금' },
  { value: 'ETC', label: '기타' },
];

export const PAYMENT_TYPE_COLORS: Record<string, string> = {
  DEPOSIT: 'bg-yellow-100 text-yellow-700',
  CONTRACT: 'bg-blue-100 text-blue-700',
  INTERMEDIATE: 'bg-orange-100 text-orange-700',
  BALANCE: 'bg-green-100 text-green-700',
  ETC: 'bg-gray-100 text-gray-700',
};

// 결제 상태
export const PAYMENT_STATUSES = [
  { value: 'COMPLETED', label: '결제완료' },
  { value: 'SCHEDULED', label: '결제예정' },
  { value: 'REFUNDED', label: '환불됨' },
  { value: 'CANCELLED', label: '취소됨' },
];

export const PAYMENT_STATUS_COLORS: Record<string, string> = {
  COMPLETED: 'bg-green-100 text-green-700',
  SCHEDULED: 'bg-blue-100 text-blue-700',
  REFUNDED: 'bg-orange-100 text-orange-700',
  CANCELLED: 'bg-red-100 text-red-700',
};

// 결제 수단
export const PAYMENT_METHODS = [
  { value: 'CARD', label: '카드' },
  { value: 'TRANSFER', label: '계좌이체' },
  { value: 'CASH', label: '현금' },
];

// 정산 상태
export const SETTLEMENT_STATUSES = [
  { value: '', label: '전체' },
  { value: 'PENDING', label: '미정산' },
  { value: 'SETTLED', label: '정산' },
];

export const SETTLEMENT_STATUS_COLORS: Record<string, string> = {
  PENDING: 'bg-red-100 text-red-700',
  SETTLED: 'bg-green-100 text-green-700',
};

// 조회기간 기준
export const DATE_CRITERIA = [
  { value: 'createDt', label: '등록일' },
  { value: 'contractDt', label: '계약일' },
  { value: 'eventDt', label: '행사일' },
];

// 정산 조회기간 기준
export const SETTLEMENT_DATE_CRITERIA = [
  { value: 'eventDt', label: '예식일' },
  { value: 'contractDt', label: '계약일' },
  { value: 'settledDt', label: '정산일' },
];

// 이름조회 기준
export const SEARCH_CRITERIA = [
  { value: 'all', label: '전체' },
  { value: 'groom', label: '신랑' },
  { value: 'bride', label: '신부' },
  { value: 'contact', label: '담당자' },
  { value: 'phone', label: '전화번호' },
];

// 홀 상태
export const VENUE_STATUSES = [
  { value: 'ACTIVE', label: '운영중' },
  { value: 'INACTIVE', label: '미운영' },
  { value: 'MAINTENANCE', label: '보수중' },
];

export const VENUE_STATUS_COLORS: Record<string, string> = {
  ACTIVE: 'bg-green-100 text-green-700',
  INACTIVE: 'bg-gray-100 text-gray-700',
  MAINTENANCE: 'bg-orange-100 text-orange-700',
};

// 추가매출 품목 카테고리
export const ITEM_CATEGORIES = [
  { value: 'MEAL', label: '식대' },
  { value: 'VENUE_RENTAL', label: '대관료' },
  { value: 'FLOWER', label: '꽃/장식' },
  { value: 'PHOTO', label: '포토' },
  { value: 'VIDEO', label: '영상' },
  { value: 'PYROTECHNICS', label: '폭죽/특수효과' },
  { value: 'ETC', label: '기타' },
];
